import { Controller } from "stimulus";

// Lets the form's confirm trigger (modal#open) open its dialog only when this submit turns the
// watched switch on; any other submit, Enter in a field included, skips the dialog. Runs in the
// capture phase, before the trigger's own action. "Turning on" is judged against the stored setting
// (the enabled value), since a query string or form restoration can tick the switch before connect.
export default class extends Controller {
  static targets = ["switch", "trigger"];
  static values = { enabled: Boolean };

  confirm(event) {
    if (this.enabling || !this.triggerTarget.contains(event.target)) return;

    event.stopPropagation();
  }

  get enabling() {
    return this.switchTarget.checked && !this.enabledValue;
  }
}
